import React from "react";
import type { SortDir, SortKey } from "../../../types";

export const MobileSortBar = ({
                                  options,
                                  sortKey,
                                  sortDir,
                                  onSortKey,
                                  onToggleDir,
                              }: {
    options: { key: SortKey; label: string }[];
    sortKey: SortKey;
    sortDir: SortDir;
    onSortKey: (k: SortKey) => void;
    onToggleDir: () => void;
}) => {
    return (
        <div className="flex flex-col gap-2 px-4 pt-4 sm:px-5 xl:hidden">
            <div className="flex items-center justify-between">
                <span className="text-xs font-semibold text-slate-500">Сортировка</span>

                <button
                    type="button"
                    onClick={onToggleDir}
                    className="h-9 rounded-full border border-slate-200 bg-white px-3 text-xs font-semibold text-slate-600 transition hover:bg-slate-50"
                    title="Направление сортировки"
                >
                    {sortDir === "asc" ? "↑" : "↓"}
                </button>
            </div>

            <div className="flex flex-wrap gap-2">
                {options.map((o) => {
                    const active = sortKey === o.key;

                    return (
                        <button
                            key={o.key}
                            type="button"
                            onClick={() => onSortKey(o.key)}
                            className={[
                                "h-9 rounded-full border px-3 text-xs font-semibold transition",
                                active
                                    ? "border-[rgba(192,97,152,0.35)] bg-[rgba(192,97,152,0.10)] text-[#c06198]"
                                    : "border-slate-200 bg-white text-slate-600 hover:bg-slate-50",
                            ].join(" ")}
                        >
                            {o.label}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};
